<section class="content">
    <section>
        <div class="row">
        <div class="box  box-primary">
                <PageHeader class="pageHeaderButtonPosition" *ngIf="!isDialogFromPartsComponent"  title="Update Inventory" [showSearch]="false" [showMainListing]="false" [showCancel]="isDialogFromPartsComponent" (CancelEvent)="cancelDialog()"></PageHeader>  
                <div class="row align-items-center mb-3" *ngIf="isDialogFromPartsComponent">
                        <div class="col-sm-6 text-left">
                                <h3 class="m-0" style="margin-left: 20px;">Update Inventory</h3>
                        </div>

                       <div class="col-sm-6 text-right">
                                <button class="cancel-icon-btn" (click)="cancelDialog()">
                                <i class="pi pi-times" style="font-size: 2rem;"></i>
                                </button>
                        </div>
                </div>

                <div class="box-body">
                        <div class="d-none d-md-block">
                                <div class="row box-row">
                                        <div class="col box-row">
                                                <div class="col-sm-1 text-center" style="max-width:60px;">

                                                </div>
                                                <div class="col-sm-2 text-center">
                                                        <strong>Part ID</strong>
                                                </div>
                                                <div class="col-sm-3 text-center">
                                                        <strong>Part Description</strong>
                                                </div>
                                                <div class="col-sm-2 text-center">
                                                        <strong>Division</strong>
                                                </div>
                                                <div class="col-sm-1 text-center">
                                                        <strong>Part Qty.</strong>
                                                </div>
                                                <div class="col-sm-1 text-center">
                                                        <strong>Action</strong>
                                                </div>
                                                <div class="col-sm-2 text-center">
                                                        <strong>Ref No.</strong>
                                                </div>
                                                
                                        </div>
                                </div>
                                <div class="row">
                                <div class="col-sm-12 box-row">
                                                <div class="col-sm-1 text-center" style="max-width:60px;padding-left: 0px;">
                                                <img src="../../assets/img/scan icon.png"
                                                alt="Scan Icon"
                                                (click)="openBarcodeScanner()"
                                                class="scan-image-button" />
                                        </div>
                                        <div class="col-sm-2 text-center">
                                                <input type="text" class="form-control" (keyup)="PartCodeChange('code')"
                                                        [(ngModel)]="PartSearchTerm" matInput="PartSearchTerm" name="PartSearchTerm"
                                                        [matAutocomplete]="autopart" [disabled]="isDialogFromPartsComponent">
                                                <mat-autocomplete (optionSelected)='getPartCosts($event.option,"code")'
                                                        #autopart="matAutocomplete">
                                                        <mat-option *ngFor="let item of partSearchResult" [value]="item.equipmentcode">
                                                                {{ item.equipmentcode }}
                                                        </mat-option>
                                                </mat-autocomplete>

                                        </div>
                                        <div class="col-sm-3">
                                                <input type="text" (keyup)="PartCodeChange('desc')" class="form-control"
                                                        matInput name="partDescription" [value]="PartSelectedItem.desc" [disabled]="isDialogFromPartsComponent"
                                                        [(ngModel)]="partsDetails.partDescription" [matAutocomplete]="autopartdesc">
                                                <mat-autocomplete (optionSelected)='getPartCosts($event.option,"desc")'
                                                        #autopartdesc="matAutocomplete">
                                                        <mat-option *ngFor="let item of partSearchResult" [value]="item.equipmentDesc">
                                                                {{ item.equipmentDesc }}
                                                        </mat-option>
                                                </mat-autocomplete>
                                        </div>
                                        <div class="col-sm-2 text-center">
                                        <select class="form-control"
                                                [(ngModel)]="partsDetails.divisionId"
                                                name="divisionId" [disabled]="isDialogFromPartsComponent && partsDetails.divisionId > 0"
                                                (change)="onDivisionChange($event)">
                                                <option *ngFor="let item of DivisionList" [value]="item.value">
                                                {{ item.text }}
                                                </option>
                                        </select>
                                        </div>
                                        
                                        <div class="col-sm-1 text-center" style="padding-right: 0px !important;padding-left: 0px !important;">
                                                <select class="form-control mdInput center-block custom-panel"
                                                        style="width:70px; float:none"
                                                        (change)="SetCost()"  
                                                        [(ngModel)]="partsDetails.quantity" 
                                                        name="quantity">
                                                        <option *ngFor="let item of PartQtyList" [value]="item.value">
                                                        {{item.text}}
                                                        </option>
                                                </select>
                                                <label *ngIf="selectedDivisionQty" style="display:inline-block !important;font-weight: normal;margin-left: 4px;">
                                                        ({{selectedDivisionQty}})
                                                </label>
                                        </div>

                                        <div class="col-sm-1 text-center">
                                        <select [(ngModel)]="selectedPartAction"  
                                                class="form-control mdInput center-block custom-panel"
                                                style="width:120px; float:none;" (change)="onPartActionChange($event)">
                                                <option *ngFor="let item of partActionList" [value]="item.value">
                                                        {{ item.text }}
                                                </option>
                                        </select>
                                        </div>
                                        <div class="col-sm-1 text-center">
                                                <input type="text" [disabled]="isDialogFromPartsComponent"
                                                        class="form-control"
                                                        name="refNumber"  maxlength="20"
                                                        [(ngModel)]="partsDetails.refNumber"
                                                        (ngModelChange)="validateRefNumber($event)"
                                                        style="margin-left:20px !important;width:130px; float:none;"
                                                        [disabled]="!isRefNumberEnabled">
                                        </div>
                                        
                                                <div class="col-sm-1 ">
                                                <button (click)="saveAndClose()" class="btn btn-primary btn-label-left center-block p-5" style="margin-left: 60px;"
                                                        type="button">
                                                        <span><i class="fa fa-plus"></i></span>
                                                        <b> Save</b>
                                                </button>
                                        </div>
                                </div>
                                </div>
                        </div>

                        <div class="d-block d-md-none">
                                <div class="card p-2 mb-2">
                                        <div class="col-sm-6">
                                              <div class="col-sm-3 text-center" >
                                                <img src="../../assets/img/scan icon.png"
                                                alt="Scan Icon"
                                                (click)="openBarcodeScanner()"
                                                class="scan-image-button" />
                                        </div>
                                        </div>
                                        <div class="col-sm-6">
                                                <label class="col-sm-5 control-label">Part ID</label>
                                                <div class="col-sm-7">
                                                           <input type="text" class="form-control" (keyup)="PartCodeChange('code')"
                                                        [(ngModel)]="PartSearchTerm" matInput="PartSearchTerm" name="PartSearchTerm"
                                                        [matAutocomplete]="autopart" [disabled]="isDialogFromPartsComponent">
                                                <mat-autocomplete (optionSelected)='getPartCosts($event.option,"code")'
                                                        #autopart="matAutocomplete">
                                                        <mat-option *ngFor="let item of partSearchResult" [value]="item.equipmentcode">
                                                                {{ item.equipmentcode }}
                                                        </mat-option>
                                                </mat-autocomplete>
                                                </div>
                                        </div>
                                      
                                        <div class="col-sm-6">
                                                <label class="col-sm-5 control-label">Part Description</label>
                                                <div class="col-sm-7">
                                                        <input type="text" (keyup)="PartCodeChange('desc')" class="form-control"
                                                                        matInput name="partDescription" [value]="PartSelectedItem.desc" [disabled]="isDialogFromPartsComponent"
                                                                        [(ngModel)]="partsDetails.partDescription" [matAutocomplete]="autopartdesc">
                                                        <mat-autocomplete (optionSelected)='getPartCosts($event.option,"desc")'
                                                                #autopartdesc="matAutocomplete">
                                                                <mat-option *ngFor="let item of partSearchResult" [value]="item.equipmentDesc">
                                                                        {{ item.equipmentDesc }}
                                                                </mat-option>
                                                        </mat-autocomplete>
                                                </div>
                                        </div>

                                        <div class="col-sm-6">
                                                <label class="col-sm-5 control-label">Division</label>
                                                <div class="col-sm-7">
                                                <select class="form-control"
                                                        [(ngModel)]="partsDetails.divisionId"
                                                        name="divisionId" [disabled]="isDialogFromPartsComponent && partsDetails.divisionId > 0"
                                                        (change)="onDivisionChange($event)">
                                                        <option *ngFor="let item of DivisionList" [value]="item.value">
                                                        {{ item.text }}
                                                        </option>
                                                </select>
                                                </div>
                                        </div>

                                        <div class="col-sm-6">
                                                <label class="col-sm-5 control-label">Part Qty.</label>
                                                <div class="col-sm-7">
                                                        <select class="form-control mdInput center-block custom-panel"
                                                                (change)="SetCost()"  
                                                                [(ngModel)]="partsDetails.quantity" 
                                                                name="quantity">
                                                                <option *ngFor="let item of PartQtyList" [value]="item.value">
                                                                {{item.text}}
                                                                </option>
                                                        </select>
                                                        <label *ngIf="selectedDivisionQty" style="display:inline-block !important;font-weight: normal;margin-left: 4px;">
                                                                ({{selectedDivisionQty}})
                                                        </label>
                                                </div>
                                        </div>
                                         
                                      <div class="col-sm-6">
                                                <label class="col-sm-5 control-label">Action</label>
                                                <div class="col-sm-7">
                                                <select [(ngModel)]="selectedPartAction"  
                                                        class="form-control mdInput center-block custom-panel"
                                                       (change)="onPartActionChange($event)">
                                                        <option *ngFor="let item of partActionList" [value]="item.value">
                                                                {{ item.text }}
                                                        </option>
                                                </select>
                                                </div>
                                        </div>
 
                                          <div class="col-sm-6">
                                                <label class="col-sm-5 control-label">Ref No.</label>
                                                <div class="col-sm-7">
                                                   <input type="text" [disabled]="isDialogFromPartsComponent"
                                                        class="form-control"
                                                        name="refNumber"  maxlength="20"
                                                        [(ngModel)]="partsDetails.refNumber"
                                                        (ngModelChange)="validateRefNumber($event)"
                                                        [disabled]="!isRefNumberEnabled">
                                                </div>
                                        </div>

                                        <div class="col-sm-6">
                                                <button (click)="saveAndClose()" class="btn btn-primary btn-label-left center-block p-5" style="margin-top: 20px;" type="button">
                                                <span><i class="fa fa-plus"></i></span>
                                                <b> Save</b>
                                                </button>
                                        </div>
                                </div>
                        </div>

                        <div class="row text-center">
                                <span class="error" style="font-size: 12px;">{{parterrormsg}}</span>
                                <br>
                                <span class="error" *ngIf="noteparterrormsg">{{noteparterrormsg}}</span>
                        </div>
                        <div class="table-responsive-custom">
                                <table  class="table table-bordered table-striped dataTable no-footer" role="grid">
                                <thead>
                                        <tr class="text-center">
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>User</th>
                                        <th>Part ID</th>
                                        <th>Description</th>
                                        <th>Division</th>
                                        <th>Qty</th>
                                        <th>Type</th>
                                        <th>Ref No.</th>
                                        <th>Updated</th>
                                        <th>Action</th>
                                        </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let item of PartList"  [class.fade-out]="item.isDeleted"> 
                                                <td>{{item.createdOn | date:'dd/MM/yyyy'}}</td>
                                                <td>{{item.createdOn | date:'HH:mm'}}</td>
                                                <td>{{item.user}}</td>
                                                <td>{{item.equipmentCode}}</td>
                                                <td>
                                                <a *ngIf="!isDialogFromPartsComponent" (click)="onEquipmentClick(item)">{{ item.equipmentDesc }}</a>
                                                <span *ngIf="isDialogFromPartsComponent">{{ item.equipmentDesc }}</span>
                                                </td>
                                                <td>{{item.divisionFullName}}</td>
                                                <td>{{item.quantity}}</td>
                                                <td><span *ngIf="item.type === 'INV'" style="color: red;">* </span>{{item.type}}</td>
                                                <td>
                                                <span *ngIf="item.type === 'RECNEW'">{{item.refNo}}</span>
                                                <span *ngIf="item.type !== 'RECNEW'"></span>
                                                </td>                                        
                                                <td>
                                                <div class="progressbar-wrapper">
                                                        <ul class="progressBar">	
                                                        <li 
                                                        class="progressBar" 
                                                        [ngClass]="{
                                                        'progressbarorange': item.type === 'INV',
                                                        'progressBarlightGreen': item.type !== 'INV'
                                                        }">
                                                        <i class="fa fa-check"></i>
                                                        </li>
                                                        </ul>
                                                </div>
                                                </td>
                                                <td>
                                                <button type="button" style="padding: 4px 8px !important;"
                                                        *ngIf="item.canDelete && !item.isDeleted && item.type !== 'INV'"
                                                        class="btn btn-danger btn-label-left center-block btn-xs"
                                                        (click)="deletePartQuantity(item)">
                                                <span><i class="fa fa-times"></i></span>
                                                </button>

                                                <label *ngIf="item.isDeleted">Deleted</label>
                                                </td>  
                                        </tr>
                                </tbody>
                                </table>
                        </div>
                </div>                
        </div>
        </div>
    </section>
</section>        
 